<div class="container">
  <div class="logo mb-2 text-center" style="margin: auto;">
    <img src="../../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="" routerLink="/">
    <h5 class="display-5 mb-5">Payment Successful!</h5>
  </div>

  <div class="alert alert-success text-center" role="alert">
    Your appointment has been successfully raised!
  </div>

  <div class="main-content">
    <div class="row">
      <div class="col-5" style="text-align: right;">
        <p style="font-weight: bold;">Name:</p>
      </div>
      <div class="col-7">
        <p>{{ selectedAppointment.fullName }}</p>
      </div>

      <!-- <div class="col-5" style="text-align: right;">
        <p style="font-weight: bold;">Email:</p>
      </div>
      <div class="col-7">
        <p>{{ selectedAppointment.email }}</p>
      </div> -->

      <div class="col-5" style="text-align: right;">
        <p style="font-weight: bold;">Service:</p>
      </div>
      <div class="col-7">
        <p>{{ selectedServiceName }}</p>
      </div>

      <div class="col-5" style="text-align: right;">
        <p style="font-weight: bold;">Date:</p>
      </div>
      <div class="col-7">
        <p>{{ selectedAppointment.createdAt | date: 'dd MMM yyyy, hh:MM a' }}</p>
      </div>

      <div class="col-5" style="text-align: right;">
        <p style="font-weight: bold;">Amount Paid:</p>
      </div>
      <div class="col-7">
        <p>$ {{ selectedAppointment.paymentAmount }}</p>
      </div>
    </div>
    <button type="button" class="btn btn-block btn-outline-dark" routerLink="/">Back to home</button>
  </div>
</div>
